import * as actionTypes from '../../constants/actionTypes';
import DataSamplesProcessor from '../../lib/DataSamplesProcessor';
import { getTestCodeForCustomAttrTx } from 'js/lib/TransformsUtils';

import DataSchemaProcessor from '../../lib/DataSchemaProcessor';

import JSONUtils from '../../lib/JSONUtils';

import {
  addCredential,
  addCredentialsGroup,
  addDataset,
  createAttributeTransform,
  createCodeContainer,
  createSchemaSpec,
  fetchSamplesForTransform,
  fetchSamplesFromFlatToNestedTransform,
  getDataCredential,
  updateAttributeTransform,
  updateCodeContainer,
  updateCredential,
  updateDataSetInfo,
  updateSchemaSpec,
  verifyCredentialSilent,
} from 'js/actions';
import { activateSource, addDataSource, updateSourceInfo } from '../sources';
import { addDataSink, updateSinkInfo } from '../sinks';
import { addDetectedDataset, addDetectedDatasetSamples } from '../dataSets';
import AnalyticsUtils from 'js/lib/AnalyticsUtils';

import {
  find,
  forEach,
  has,
  isArray,
  isEmpty,
  isNil,
  isPlainObject,
  isString,
  map,
  union,
} from 'lodash';
import { tryCatchAsync } from 'new/utils/TryCatch';

export const startForm = (formType) => {
  return {
    type: actionTypes.FORM_START,
    payload: {
      formType,
    },
  };
};

export const dismissForm = (formType) => {
  return {
    type: actionTypes.FORM_DID_DISMISS,
    payload: {
      formType,
    },
  };
};

export const finishForm = (formType) => {
  return {
    type: actionTypes.FORM_DID_END,
    payload: {
      formType,
    },
  };
};

export const formDidTransitionToNext = (formType) => {
  return {
    type: actionTypes.FORM_DID_TRANSITION_TO_NEXT,
    payload: {
      formType,
    },
  };
};

export const formDidTransitionToPrev = (formType) => {
  return {
    type: actionTypes.FORM_DID_TRANSITION_TO_PREV,
    payload: {
      formType,
    },
  };
};

export const updateFormData = (formType, formData = {}, resetValidationStatus = true) => {
  return {
    type: actionTypes.FORM_DID_UPDATE_STAGE_DATA,
    payload: {
      formType,
      formData,
      resetValidationStatus,
    },
  };
};

export const resetFormData = (formType, resetFields, resetValidationStatus = true) => {
  return {
    type: actionTypes.FORM_DID_RESET_STAGE_DATA,
    payload: {
      formType,
      resetFields,
      resetValidationStatus,
    },
  };
};

export const setFormDialog = (formType, isOpen) => {
  return {
    type: actionTypes.FORM_DID_SET_DIALOG,
    payload: {
      formType,
      isOpen,
    },
  };
};

export const setFormError = (formType, error) => {
  return {
    type: actionTypes.FORM_DID_SET_ERROR,
    payload: {
      formType,
      error,
    },
  };
};

export const clearFormError = (formType) => {
  return {
    type: actionTypes.FORM_DID_CLEAR_ERROR,
    payload: {
      formType,
    },
  };
};

export const setFormAwaitingValidation = (formType, awaitingValidation) => {
  return {
    type: actionTypes.FORM_DID_UPDATE_VALIDATION_STATUS,
    payload: {
      formType,
      awaitingValidation,
    },
  };
};

export const setFormStageIndex = (formType, stageIndex) => {
  return {
    type: actionTypes.FORM_DID_SET_STAGE_INDEX,
    payload: {
      formType,
      stageIndex,
    },
  };
};

export const markFormCompleted = (formType, isComplete = true) => {
  return {
    type: actionTypes.FORM_DID_COMPLETE,
    payload: {
      formType,
      isComplete,
    },
  };
};

//Actions for Different Form Wizards

//1. Create Data Source Form
export const addCredentialFromForm = (formType, credentialType, credentialInfo) => (dispatch) => {
  return dispatch(addCredential(credentialType, credentialInfo))
    .then((response) => {
      let { result, entities } = response;
      let credentialCreationStatus = {
        message: null,
        credential: result,
        credentialObj: entities.credentials[result],
      };
      dispatch(
        updateFormData(formType, {
          credentialCreationStatus: credentialCreationStatus,
        }),
      );
      return response;
    })
    .catch((error) => {
      console.log(`${formType}: Error creating credential`);
      console.log(error);
      let credentialCreationStatus = {
        message: 'There was an error saving the credential',
        credential: null,
      };
      return dispatch(
        updateFormData(
          formType,
          {
            credentialCreationStatus: credentialCreationStatus,
          },
          false,
        ),
      );
    });
};

export const updateCredentialFromForm = (formType, credentialId, credentialInfo) => (dispatch) => {
  return dispatch(updateCredential(credentialId, credentialInfo))
    .then((response) => {
      let { result, entities } = response;
      let credentialCreationStatus = {
        message: null,
        credential: result,
        credentialObj: entities.credentials[result],
      };
      dispatch(
        updateFormData(formType, {
          credentialCreationStatus: credentialCreationStatus,
        }),
      );
    })
    .catch((error) => {
      console.log(`${formType}: Error saving credential`);
      console.log(error);
      let credentialCreationStatus = {
        message: 'There was an error saving the credential',
        credential: null,
      };
      dispatch(
        updateFormData(formType, {
          credentialCreationStatus: credentialCreationStatus,
        }),
      );
    });
};

export const verifyCredentialFromForm = (formType, credentialId) => (dispatch) => {
  return dispatch(verifyCredentialSilent(credentialId))
    .then(() => {
      const credentialProbeStatus = {
        credential: credentialId,
        isValid: true,
        message: null,
      };
      return dispatch(updateFormData(formType, { credentialProbeStatus }));
    })
    .catch((error) => {
      const message =
        (error && (error.message || error.error)) || 'Unable to validate credentials.';
      const credentialProbeStatus = {
        credential: credentialId,
        isValid: false,
        message,
      };
      dispatch(updateFormData(formType, { credentialProbeStatus }));
      return Promise.reject(error);
    });
};

export function addDataSourceFromForm(
  formType,
  sourceType,
  connectionCategory = null,
  sourceInfo,
  credentialId,
  ignoreCredentials = false,
  shouldActivateSource = true,
  shouldForceCreateDataset = false,
  parentDataSetId = null,
  flowType = null,
) {
  return async (dispatch) => {
    let dataSourceId;
    let source;

    if (flowType === 'api_server' && parentDataSetId) {
      sourceInfo = {
        ...sourceInfo,
        parent_data_set_id: parentDataSetId,
      };
    }

    const { data: response, error } = await tryCatchAsync(
      dispatch(
        addDataSource(sourceType, connectionCategory, sourceInfo, credentialId, ignoreCredentials),
      ),
    );

    if (error) {
      console.log(`${formType}: Error creating source`);
      console.log(error);
      return dispatch(updateFormData(formType, { addedDataSource: null, source }));
    }

    dataSourceId = response.result;
    source = response?.entities?.sources?.[response.result];

    // new source; create credential group if this is an adaptive flow
    if (source?.['adaptive_flow'] === true) {
      try {
        const groupName = `Credential Group - ${source.name}`;
        const { data: credentialGroupResponse } = await tryCatchAsync(
          dispatch(addCredentialsGroup(groupName, [credentialId], sourceType)),
        );

        if (credentialGroupResponse?.result) {
          // update source with credential group ID
          await dispatch(
            updateSourceInfo(
              dataSourceId,
              { data_credentials_group_id: credentialGroupResponse.result },
              connectionCategory,
              credentialId,
            ),
          );
        }
      } catch (error) {
        console.log(`${formType}: Error creating credential group`);
        console.log(error);
      }
    }

    if (shouldForceCreateDataset) {
      //note this is temporary solution only for specific use cases where we need to force create a detected dataset for improved usability.
      const datasetInfo = {
        name: `Dataset for ${source?.name}`,
      };
      const { data: datasetResponse, error: datasetError } = await tryCatchAsync(
        dispatch(addDetectedDataset(datasetInfo, dataSourceId)),
      );

      let datasetId = datasetResponse?.result;

      //now add samples to this dataset.
      const samples = [{ source_id: dataSourceId, dataset_id: datasetId }];
      const { data: samplesResponse, error: samplesError } = await tryCatchAsync(
        dispatch(addDetectedDatasetSamples(datasetId, samples)),
      );
    }

    if (shouldActivateSource) {
      const { error } = await tryCatchAsync(dispatch(activateSource(dataSourceId)), (error) => {
        console.log(`${formType}: Error activating source`);
        console.log(error);
      });

      if (error) {
        console.error(error);
      }
    }

    if (response) {
      // Track API server target creation in PostHog
      if (flowType === 'api_server' && source) {
        AnalyticsUtils.captureCustomEvent('api_server_target_created', {
          source_type: sourceType,
          connection_category: connectionCategory,
        });
      }

      return dispatch(
        updateFormData(formType, {
          addedDataSourceId: dataSourceId,
          source,
        }),
      );
    }
    return response;
  };
}

export const updateDataSourceFromForm =
  (
    formType,
    dataSourceId,
    sourceInfo,
    connectionCategory,
    shouldActivateSource = false,
    selectedCredentialId = null,
    sourceType = null,
    credentialGroupId = null,
    runWithIngestion = false,
  ) =>
  async (dispatch) => {
    // updated source; create credential group if adaptive flow & no credential group id
    if (
      (sourceInfo?.source_config?.['adaptive_flow'] === true ||
        sourceInfo?.template_config?.['adaptive_flow'] === true) &&
      !credentialGroupId
    ) {
      try {
        const groupName = `Credential Group - ${sourceInfo.name}`;
        const { data: credentialGroupResponse } = await tryCatchAsync(
          dispatch(addCredentialsGroup(groupName, [selectedCredentialId], sourceType)),
        );

        if (credentialGroupResponse?.result) {
          // Update source with credential group ID
          sourceInfo = {
            ...sourceInfo,
            data_credentials_group_id: credentialGroupResponse.result,
          };
        }
      } catch (error) {
        console.log(`${formType}: Error creating credential group`);
        console.log(error);
      }
    }

    return dispatch(
      updateSourceInfo(
        dataSourceId,
        sourceInfo,
        connectionCategory,
        selectedCredentialId,
        runWithIngestion,
      ),
    )
      .then(
        (response) => {
          let source = response?.entities?.sources?.[dataSourceId];
          return dispatch(
            updateFormData(formType, {
              addedDataSourceId: dataSourceId,
              source,
            }),
          );
        },
        (error) => {
          console.log(`${formType}: Error updating source`);
          console.log(error);
        },
      )
      .then(
        (response) => {
          return shouldActivateSource
            ? dispatch(activateSource(dataSourceId))
            : Promise.resolve(response);
        },
        (error) => {
          console.log(`${formType}: Error activating source`);
          console.log(error);
        },
      );
  };

//Create Nexset Workflow
export const addDatasetFromForm =
  (
    formType,
    info,
    parentDataSetId,
    transformSpec,
    outputValidations,
    outputSchema,
    rawOutputSchema,
    rawOutputSamples,
  ) =>
  (dispatch) => {
    const newInfo = { ...info, transformSpec };

    return (
      dispatch(
        addDataset(
          newInfo,
          parentDataSetId,
          outputValidations,
          outputSchema,
          rawOutputSchema,
          rawOutputSamples,
        ),
      )
        // .then((response) => {
        //   //set passed, sink (if present) passed. now add sharers.
        //
        //   if (!isNil(addedDatasetId) && sharers && sharers.length > 0) {
        //     return dispatch(
        //       replaceDatasetSharersAndFetch(
        //         addedDatasetId,
        //         map(sharers, (s) => pick(s, ['email', 'org_id']))
        //       )
        //     );
        //   }
        //   return { result: addedDatasetId };
        // })
        .then((response) => {
          const { result: addedDatasetId } = response;

          dispatch(markFormCompleted(formType));
          return dispatch(updateFormData(formType, { addedDatasetId }));
        })
        .catch((error) => {
          //could be Nexset failed
          //could be datasink failed
          //could be sharers failed
          console.log('error in Nexset creation');
          console.log(error);
        })
    );
  };

export const updateSinkInfoFromForm =
  (formType, id, newInfo = {}) =>
  (dispatch) => {
    dispatch(updateFormData(formType, { updatedDataSinkId: null }));
    return dispatch(updateSinkInfo(id, newInfo))
      .then((response) => {
        const { result, entities } = response;
        const sink = entities?.sinks?.[result];
        return dispatch(updateFormData(formType, { updatedDataSinkId: result, sink }));
      })
      .catch((error) => {
        console.log(`${formType}: Error updating sink`);
        console.log(error);
        dispatch(
          updateFormData(formType, {
            updatedDataSinkId: null,
            updatedDataSinkError: error,
            updatedDatasetError: null,
          }),
        );
        return Promise.reject(error);
      });
  };

export const updateSinkTypeFromForm =
  (formType, sinkType, sinkInfo = null, credentialId = null) =>
  (dispatch, getState) => {
    let addedDataSinkId;
    let sink;

    return dispatch(addDataSink(sinkType, sinkInfo, credentialId))
      .then((response) => {
        const {
          entities: { dataSets },
        } = getState();
        const { result, entities } = response;
        addedDataSinkId = result;
        sink = entities?.sinks[result];
        const dataSet = dataSets[sinkInfo.data_set_id];
        const dataSinkIds = dataSet?.data_sinks || dataSet?.data_sink_ids || [];

        return dispatch(
          updateDataSetInfo(sinkInfo.data_set_id, {
            data_sinks: union(dataSinkIds, [addedDataSinkId]),
          }),
        );
      })
      .then((response) => {
        return dispatch(updateFormData(formType, { addedDataSinkId: addedDataSinkId, sink }));
      })
      .catch((error) => {
        console.log(`${formType}: Error creating sink`);
        console.log(error);
        dispatch(
          updateFormData(formType, {
            addedDataSinkId: null,
            addedDataSinkError: error,
          }),
        );

        // return Promise.reject(error);
      });
  };

export const fetchTransformedPayloadFromEditorForRest =
  (txObject, inSamples, dataSetId) => (dispatch, getState) => {
    const {
      forms: { activeType },
    } = getState();

    return dispatch(fetchSamplesFromFlatToNestedTransform(txObject, inSamples, dataSetId)).then(
      (response) => {
        const {
          result: { output, status },
        } = response;
        if (status === 'ok') {
          const previewPayload = map(output, 'rawMessage');

          dispatch(
            updateFormData(activeType, {
              dataSetId,
              previewPayload,
              previewPayloadError: null,
            }),
          );
        } else {
          dispatch(
            updateFormData(activeType, {
              previewPayload: null,
              previewPayloadError: 'Error in getting samples.',
            }),
          );
        }
      },
      (error) => {
        dispatch(
          updateFormData(activeType, {
            dataSetId,
            previewPayload: null,
            previewPayloadError: error.msg || error.error,
          }),
        );
      },
    );
  };

/**
 * @param tx
 * @param inputSample = {}
 * @param args = []
 * @returns {(function(*, *): void)|*}
 */
export const testAttributeTransform =
  ({ tx = null, inputSample, inputArgumentsTestData: args }) =>
  (dispatch, getState) => {
    const ID = 1; // don't change it
    const { activeType } = getState().forms;

    const hasEssentialProperties =
      has(tx, 'code') && has(tx, 'code_encoding') && has(tx, 'code_type');

    if (!hasEssentialProperties) {
      dispatch(updateFormData(activeType, { output: 'Error' }));
      return;
    }

    const { code, code_encoding, code_type } = tx;
    const rawMessage = { ...inputSample };
    const testInputSample = [{ rawMessage, nexlaMetaData: {} }];
    const testCodeTxObject = getTestCodeForCustomAttrTx(ID, args);

    testCodeTxObject.transforms.push({
      operation: 'nexla.custom.attribute',
      spec: { id: ID, code, code_encoding, code_type },
    });

    testCodeTxObject.transforms.push({
      operation: 'shift',
      spec: { nexTestTxOut: 'nexTestTxOut' },
    });

    dispatch(
      fetchSamplesForTransform(
        testCodeTxObject,
        {},
        null,
        null,
        testInputSample,
        null,
        true,
        false,
        false,
        false,
      ),
    )
      .then((response) => {
        const txOutput = response?.result?.output ?? null;
        const firstRecord = txOutput?.[0] ?? null;

        if (firstRecord.rawMessage === null || firstRecord.error) {
          const message = firstRecord?.error?.message
            ? firstRecord?.error?.message
            : 'Something is wrong, please check your code';
          throw new Error(message);
        }

        let outputValue = (function () {
          if ('nexTestTxOut' in firstRecord.rawMessage)
            return firstRecord?.rawMessage?.nexTestTxOut;
          return firstRecord?.rawMessage || '';
        })();

        if (!isString(outputValue)) {
          outputValue = JSONUtils.parseToFormat(outputValue, 'application/json');
        }

        dispatch(updateFormData(activeType, { output: outputValue }));
      })
      .catch((e) => {
        console.log('failure fetching samples');
        dispatch(updateFormData(activeType, { output: '' }));
        dispatch(setFormError(activeType, e?.message));
      });
  };

export const createAttrTxFromForm =
  (formType, attrTxPayload = null) =>
  (dispatch) => {
    return dispatch(createAttributeTransform(attrTxPayload)).then(
      (response) => {
        let { result } = response;
        dispatch(
          updateFormData(formType, {
            txUpdateDone: true,
            txUpdateId: result,
            txUpdateError: null,
          }),
        );

        return response;
      },
      (error) => {
        console.error(`${formType}: Error creating TX: `, error);
        dispatch(
          updateFormData(formType, {
            txUpdateDone: true,
            txUpdateId: null,
            txUpdateError: error,
          }),
        );
      },
    );
  };

export const updateAttrTxFromForm =
  (formType, transformId = null, attrTxPayload = null) =>
  (dispatch) => {
    return dispatch(updateAttributeTransform(transformId, attrTxPayload)).then(
      (response) => {
        let { result } = response;
        dispatch(
          updateFormData(formType, {
            txUpdateDone: true,
            txUpdateId: result,
            txUpdateError: null,
          }),
        );
      },
      (error) => {
        console.log(`${formType}: Error creating Tx\n`, error);
        dispatch(
          updateFormData(formType, {
            txUpdateDone: true,
            txUpdateId: null,
            txUpdateError: error,
          }),
        );
      },
    );
  };

//REUSABLE RECORD TRANSFORMS
export const testReusableRecordTransform =
  (recordTxCode = null, inputSamples = [{}]) =>
  (dispatch, getState) => {
    const {
      forms: { activeType },
    } = getState();

    // no need to create reusable tx before saving.
    //  just trigger a transform samples run with custom tx payload

    let testSample = isArray(inputSamples)
      ? map(inputSamples, (s) => ({
          rawMessage: s,
          nexlaMetaData: {},
        }))
      : isPlainObject(inputSamples)
        ? [
            {
              rawMessage: inputSamples,
              nexlaMetaData: {},
            },
          ]
        : [
            {
              rawMessage: {},
              nexlaMetaData: {},
            },
          ];

    return dispatch(
      fetchSamplesForTransform(
        recordTxCode, // txObject,
        {}, // saObject
        null, // transformId,
        null, // outputValidations
        testSample, // inSamples
        null, // dataSetId
        true, // include_metadata
        false, // accumulate_schema
        false, // include_annotations
      ),
    ).then(
      (response) => {
        let txOutput = has(response, 'result.output') ? response.result.output : null;
        // let outputRecords =
        //   !isNil(txOutput) && !isEmpty(txOutput) ? txOutput : null;
        let outputSamples = [];
        let error;
        //could have sent one record or multiple records
        if (!isNil(txOutput) && !isEmpty(txOutput)) {
          if (isArray(inputSamples)) {
            outputSamples = map(txOutput, (o) => o.rawMessage);
          } else if (isPlainObject(inputSamples) && has(txOutput[0], 'rawMessage')) {
            outputSamples = txOutput[0].rawMessage;
          }
          let sampleWithError = find(txOutput, (o) => o.error);
          if (sampleWithError) {
            error = sampleWithError.error.message;
          }
        }

        let outputValue = JSONUtils.parseToFormat(outputSamples, 'application/json');

        dispatch(
          updateFormData(activeType, {
            output: outputValue,
          }),
        );

        if (error) {
          dispatch(setFormError(activeType, error));
        }
      },
      (error) => {
        console.log('failure fetching samples');
        dispatch(
          updateFormData(activeType, {
            testRecordTransformMessage: error.msg || error.error,
          }),
        );
      },
    );
  };

export function createReusableRecordTxFromForm(formType, recordTxPayload) {
  return (dispatch) => {
    return dispatch(createCodeContainer(recordTxPayload)).then(
      (response) => {
        let { result } = response;
        dispatch(
          updateFormData(formType, {
            txUpdateDone: true,
            txUpdateId: result,
            txUpdateError: null,
          }),
        );

        return response;
      },
      (error) => {
        console.error(`${formType}: Error creating Tx \n`, error);
        dispatch(
          updateFormData(formType, {
            txUpdateDone: true,
            txUpdateId: null,
            txUpdateError: error,
          }),
        );
      },
    );
  };
}

export const updateReusableRecordTxFromForm =
  (formType, transformId = null, recordTxPayload = null) =>
  (dispatch) => {
    return dispatch(updateCodeContainer(transformId, recordTxPayload)).then(
      (response) => {
        let { result } = response;
        dispatch(
          updateFormData(formType, {
            txUpdateDone: true,
            txUpdateId: result,
            txUpdateError: null,
          }),
        );
      },
      (error) => {
        console.log(`${formType}: Error creating Tx`);
        console.log(error);
        dispatch(
          updateFormData(formType, {
            txUpdateDone: true,
            txUpdateId: null,
            txUpdateError: error,
          }),
        );
      },
    );
  };

export const testSchemaSpec =
  (specTxCode = null, inputSamples = [{}], testSchemaSpecID = null) =>
  (dispatch, getState) => {
    const {
      forms: { activeType },
    } = getState();
    // no need to create reusable tx before saving.
    //  just trigger a transform samples run with custom tx payload

    let testSample = isArray(inputSamples)
      ? inputSamples
      : isPlainObject(inputSamples)
        ? [inputSamples]
        : [{}];

    return dispatch(
      fetchSamplesForTransform(specTxCode, {}, null, null, testSample, null, false, true, false),
    ).then(
      (response) => {
        if (has(response, 'result.status') && response.result.status === 'ok') {
          const genSchema =
            has(response, 'result.schemas') && isArray(response.result.schemas)
              ? response.result.schemas[0]
              : null;
          const outputSamples = has(response, 'result.output') ? response.result.output : [];
          let flatSchema = DataSchemaProcessor.flattenSchema(genSchema.properties, [], 0);

          let flatSamples = [];
          forEach(outputSamples, (s) => {
            flatSamples.push(DataSamplesProcessor.flattenSamples(s));
          });

          const schema = {
            id: Date.now(),
            data_samples: outputSamples,
            schema: genSchema,
            flatSchema,
            flatSamples,
          };

          dispatch(
            updateFormData(activeType, {
              outputSchema: schema,
            }),
          );
        } else {
          //error
          console.log('status error');
          dispatch(
            updateFormData(activeType, {
              testSchemaSpecMessage: 'Could not generate schema from input samples',
            }),
          );
        }
      },
      (error) => {
        console.log('failure fetching samples');
        dispatch(
          updateFormData(activeType, {
            testSchemaSpecMessage: error.msg || error.error,
          }),
        );
      },
    );
  };

export const createSchemaSpecFromForm =
  (formType, schemaSpecPayload = null) =>
  (dispatch) => {
    return dispatch(createSchemaSpec(schemaSpecPayload)).then(
      (response) => {
        let { result } = response;
        dispatch(
          updateFormData(formType, {
            specUpdateDone: true,
            specUpdateId: result,
            specUpdateError: null,
          }),
        );
      },
      (error) => {
        console.log(`${formType}: Error creating Spec`);
        console.log(error);
        dispatch(
          updateFormData(formType, {
            specUpdateDone: true,
            specUpdateId: null,
            specUpdateError: error,
          }),
        );
      },
    );
  };

export const updateSchemaSpecFromForm =
  (formType, specId = null, schemaSpecPayload = null) =>
  (dispatch) => {
    return dispatch(updateSchemaSpec(specId, schemaSpecPayload)).then(
      (response) => {
        let { result } = response;
        dispatch(
          updateFormData(formType, {
            specUpdateDone: true,
            specUpdateId: result,
            specUpdateError: null,
          }),
        );
      },
      (error) => {
        console.log(`${formType}: Error creating Spec`);
        console.log(error);
        dispatch(
          updateFormData(formType, {
            specUpdateDone: true,
            specUpdateId: null,
            specUpdateError: error,
          }),
        );
      },
    );
  };
